import { defineStore } from 'pinia';
import _ from "lodash";

export const useCountriesStore = defineStore('countries', {
	state: () => ({
		countries: null,
		resolved_region: null,
	}),
	getters: {
		getDefaultCountry(state) {
			let defaultCountry = null;

			if (state.resolved_region) {
				defaultCountry = _.find(state.countries, {code: state.resolved_region});
			}

			if (!defaultCountry) return _.first(state.countries);

			return defaultCountry;
		},
		getCountries(state){
			return _.sortBy(state.countries, 'name');
		},
		getResolvedRegion(state) {
			return state.resolved_region;
		},
		findCountryById: (state) => (id) => {
			return _.find(state.countries, {'id': Number(id) });
		},
		findCountryByCode: (state) => (code) => {
			if (!code) return null;
			return _.find(state.countries, (c) => c.code && c.code.toUpperCase() === code.toUpperCase());
		}
	},
	actions: {
		setCountries(data) {
			this.countries = data;
		},
		setResolvedRegion(region) {
			this.resolved_region = region;
		}
	},
})
